<template>
  <v-dialog v-model="dialog" persistent max-width="1200px">
    <template v-if="!isEdit" v-slot:activator="{ on }">
      <mf-button label="Adicionar grupo de produtos" icon="add" v-on:click.native="on.click" />
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">{{ title }}</span>
      </v-card-title>
      <v-card-text>
        <product-group-dialog-content :key="contentKey" ref="productGroupDialogContent" v-model="localProductGroup" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <mf-action-buttons
          class="pb-4 pr-4"
          :primary-button="{
            text: 'Salvar',
            action: save,
            isVisible: true,
            isDisabled: false,
          }"
          :cancel-button="{
            text: 'Cancelar',
            action: cancel,
            isVisible: true,
            isDisabled: false,
          }"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ProductGroupDialogContent from './ProductGroupDialogContent'
import { v4 as uuidv4 } from 'uuid'
import cloneDeep from 'lodash/cloneDeep'
export default {
  name: 'AddProductGroupDialog',
  components: {
    ProductGroupDialogContent,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    productGroup: {
      type: Object,
    },
  },
  data: () => ({
    dialog: false,
    contentKey: 0,
    localProductGroup: null,
  }),
  computed: {
    title() {
      if (this.isEdit) return 'Editar grupo de produtos'
      return 'Adicionar grupo de produtos'
    },
  },
  watch: {
    dialog(val) {
      // Used to debounce and clean the contents of the inner component
      if (val) {
        this.contentKey += 1
        if (this.productGroup) this.localProductGroup = cloneDeep(this.productGroup)
        else this.localProductGroup = null
      } else this.$emit('input', val)
    },
    value(val) {
      if (val) this.dialog = true
    },
    productGroup(val) {
      if (val) this.localProductGroup = cloneDeep(val)
    },
  },
  mounted() {
    if (this.productGroup) this.localProductGroup = cloneDeep(this.productGroup)
  },
  methods: {
    cancel() {
      this.dialog = false
    },
    save() {
      const error = this.$refs.productGroupDialogContent.validate()
      if (error) {
        this.$snackbar({ message: 'Erro ao salvar grupo de produtos, preencha os campos corretamente.', snackbarColor: 'error' })
      } else {
        if (!this.localProductGroup.uuid) this.localProductGroup.uuid = uuidv4()
        this.$emit('save', this.localProductGroup)
        this.dialog = false
      }
    },
  },
}
</script>
